module.exports = __webpack_public_path__ + "img/Copy.5ab2a12d.svg";